module.exports = __webpack_public_path__ + "static/media/hotel_bed.6d34e701.svg";


//////////////////
// WEBPACK FOOTER
// /src/images/icons/hotel_bed.svg
// module id = 1172
// module chunks = 0